import dayjs from 'dayjs';
import { useState, useMemo, useEffect } from 'react';
import { showNotification } from '@mantine/notifications';
import { DateInput } from '@mantine/dates';
import { Accordion, TextInput, Pagination, Box, Paper, Stack, Grid, Divider, Button, Center, Stepper } from '@mantine/core';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleXmark } from '@fortawesome/free-solid-svg-icons';
import { sanitizeLog } from '../../utils/sanitizeLog';



const dateParser = (input) => {
  if (input === 'WW2') {
    return '1939-09-01';
  }
  return dayjs(input, 'DD/MM/YYYY').format('YYYY-MM-DD');
};

const AccordionWithFilter = () => {
  const [data, setData] = useState(null); // Instead of [], so we can check for "not loaded"
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);
  const PAGE_SIZE = 25;

  const [dates, setDates] = useState({});

  const [processState, setProcessState] = useState({});

  function safeUrl(input) {
    try {
      const url = new URL(input);
      if (url.protocol !== "https:" && url.protocol !== "http:") {
        throw new Error("Invalid protocol");
      }
      return url.toString();
    } catch {
      
      return null;
    }
  }

  // Helper to initialize default state if not exists
  const ensureItemState = (id) => {
    if (!processState[id]) {
      setProcessState((prev) => ({
        ...prev,
        [id]: { active: 0, status: 'Listo', loading: false },
      }));
    }
  };

  const handleExecuteAPIProcess = async (id) => {
    const { start, end } = dates[id] || {};

    if (start == undefined || end == undefined) {
      setProcessState((prev) => ({
        ...prev,
        [id]: { ...prev[id], loading: false, status: 'Debes de seleccionar 2 fechas validas', active: 1, error: true },
      }));

    } else {
      try {
        // 🧩 Step 1: Trigger the stored procedure
        const response = await axios.post(process.env.REACT_APP_API_ENP + "/sscn-back/api/reportes/generarReporte",
          { "id": id, "fecha_inicio": start, "fecha_fin": end },
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("token")}`, // Include the Bearer token
            }
          }
        );

        setProcessState((prev) => ({
          ...prev,
          [id]: { ...prev[id], loading: true, status: 'Tarea aceptada, comienza a procesar', active: 1, error: false },
        }));

        // 🧩 Step 2: Poll the status every 30 seconds
        const interval = setInterval(async () => {
          try {

            const { data } = await axios.get(process.env.REACT_APP_API_ENP + "/sscn-back/api/reportes/getStatusReportes",
              {
                headers: {
                  Authorization: `Bearer ${sessionStorage.getItem("token")}`, // Include the Bearer token
                },
                params: {
                  id: id,
                }
              }
            );

            if (data.SEMAFORO == 1) {
              setProcessState((prev) => ({
                ...prev,
                [id]: { ...prev[id], loading: true, status: data.ESTATUS_SEMAFORO, active: 1, error: false },
              }));
            }

            if (data.SEMAFORO == 0) {
              setProcessState((prev) => ({
                ...prev,
                [id]: { ...prev[id], loading: false, status: 'Archivo Listo para descarga', active: 3, error: false },
              }));
              clearInterval(interval);
            }

            if (data.SEMAFORO == 2) {
              setProcessState((prev) => ({
                ...prev,
                [id]: { ...prev[id], loading: false, sttaus: data.ESTATUS_SEMAFORO, active: 2, error: true },
              }));
              clearInterval(interval);
            }

          } catch (pollErr) {
            setProcessState((prev) => ({
              ...prev,
              [id]: { ...prev[id], loading: false, status: pollErr, active: 1, error: true },
            }));
          }
        }, 5_000);
      } catch (err) {
        setProcessState((prev) => ({
          ...prev,
          [id]: { ...prev[id], loading: false, status: err.response.data.message, active: 1, error: true },
        }));
      }
    }
  };

  const handleDateChange = (id, field, value) => {
    setDates((prev) => ({
      ...prev,
      [id]: { ...prev[id], [field]: value },
    }));
  };

  const DescargaFunction = (id) => {
    fetch(process.env.REACT_APP_API_ENP + "/sscn-back/api/utils/getS3LinkReportesCSV?id=" + id,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`, // Include the Bearer token
          "Content-Type": "application/json",
        },
      }
    )
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error while getting S3 link! status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {

        const s3Url = data?.link;
        if (!s3Url) throw new Error("S3 URL not found in response");
        showNotification({
          title: 'Listo!',
          message: 'Iniciando descarga del archivo',
          color: '#fff',
          styles: (theme) => ({
            root: {
              backgroundColor: '#25A661',
              borderColor: '#25A661',
              '&::before': { backgroundColor: theme.white },
            },
            title: { color: theme.white },
            description: { color: theme.white },
            closeButton: {
              color: theme.white,
            },
          }),
          autoClose: true,
        })
        sanitizeLog(s3Url);
        const validatedUrl = safeUrl(s3Url);
        if (!validatedUrl) return;

        const link = document.createElement("a");
        link.href = encodeURI(validatedUrl);

        link.download = "alertas.csv"; // or .csv, .txt, etc.

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch((err) => {
        showNotification({
          title: 'Error!',
          message: err.response?.data?.error ? err.response.data.error : err.message,
          color: '#fff',
          styles: (theme) => ({
            root: {
              backgroundColor: '#E93F19',
              borderColor: 'E93F19',
              '&::before': { backgroundColor: theme.white },
            },
            title: { color: theme.white },
            description: { color: theme.white },
            closeButton: {
              color: theme.white,
            },
          }),
          autoClose: false,
        })
      });
  }


  // 1. Fetch data
  useEffect(() => {
    setLoading(true);
    fetch(`${process.env.REACT_APP_API_ENP}/sscn-back/api/reportes/getReportes`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`, // Include the Bearer token
          "Content-Type": "application/json",
        },
      }
    )
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error getting info: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        setData(data);
      })
      .catch((err) => {
        showNotification({
          title: 'Error!',
          message: err.response?.data?.error ? err.response.data.error : err.message,
          color: '#fff',
          styles: (theme) => ({
            root: {
              backgroundColor: '#E93F19',
              borderColor: 'E93F19',
              '&::before': { backgroundColor: theme.white },
            },
            title: { color: theme.white },
            description: { color: theme.white },
            closeButton: {
              color: theme.white,
            },
          }),
          autoClose: false,
        })
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  // 2. Filter only if data is ready
  const filtered = useMemo(() => {
    if (!data) return [];
    return data.filter((item) =>
      item.Name.toLowerCase().includes(search.toLowerCase())
    );
  }, [data, search]);

  // 3. Paginate filtered items
  const paginated = useMemo(() => {
    const start = (page - 1) * PAGE_SIZE;
    return filtered.slice(start, start + PAGE_SIZE);
  }, [filtered, page]);

  const totalPages = Math.ceil(filtered.length / PAGE_SIZE);

  return (
    <>
      <div style={{ gridColumn: '1 / -1' }}>
        <Paper shadow="xl" radius="xl" withBorder p="xl">
          <TextInput
            label="Buscar Reporte"
            placeholder=""
            value={search}
            onChange={(event) => {
              setSearch(event.currentTarget.value);
              setPage(1); // Reset to page 1 on new search
            }}
            mb="md"
          />
          <Accordion>
            {paginated.map((item) => {
              const state = processState[item.id] || { active: 0, status: 'waiting', loading: false };

              return (
                <Accordion.Item
                  key={item.id}
                  value={item.Name}
                  onClick={() => ensureItemState(item.id)}
                >
                  <Accordion.Control>{item.Name}</Accordion.Control>
                  <Accordion.Panel style={{ backgroundColor: '#E6E6E3' }}>
                    <Box>
                      <Stack h={500} align="stretch" justify="center" gap="md">
                        {/* ---- Info Section ---- */}
                        <Grid>
                          <Grid.Col span={12}>Descripción: {item.Description}</Grid.Col>
                        </Grid>
                        <Divider my="md" />

                        {/* ---- Execute Section ---- */}
                        <Grid justify="center" align="center">
                          <Grid.Col span={3}>
                            <DateInput
                              value={dates[item.id]?.start || null}
                              onChange={(value) => handleDateChange(item.id, "start", value)}
                              dateParser={dateParser}
                              valueFormat="DD/MM/YYYY"
                              label="Fecha Inicio"
                              placeholder="DD/MM/YYYY"
                            />
                          </Grid.Col>
                          <Grid.Col span={3}>
                            <DateInput
                              value={dates[item.id]?.end || null}
                              onChange={(value) => handleDateChange(item.id, "end", value)}
                              dateParser={dateParser}
                              valueFormat="DD/MM/YYYY"
                              label="Fecha Fin"
                              placeholder="DD/MM/YYYY"
                            />
                          </Grid.Col>

                        </Grid>
                        <Grid justify="center" align="center">
                          <Grid.Col span={1}>
                            {/* <Button onClick={() => handleExecuteProcess(item.id)}>Ejecutar</Button> */}
                            <Button onClick={() => handleExecuteAPIProcess(item.id)} variant="outline" color="rgba(2, 12, 65, 1)">Ejecutar</Button>
                          </Grid.Col>
                        </Grid>

                        <Divider my="md" />

                        {/* ---- Stepper ---- */}
                        <Grid justify="center" align="center">
                          <Grid.Col span={10} style={{ margin: 'auto' }}>
                            <Stepper
                              active={state.active}
                              allowNextStepsSelect={false}
                            >
                              <Stepper.Step
                                label="Inicio"
                                description="Proceso Iniciado"
                                completedIcon={state.error && state.active === 1 ? <FontAwesomeIcon icon={faCircleXmark} /> : undefined}
                                color={state.error && state.active === 1 ? 'red' : undefined}
                              />
                              <Stepper.Step
                                label="Procesando"
                                description="Generando el archivo en la nube"
                                completedIcon={state.error && state.active === 2 ? <FontAwesomeIcon icon={faCircleXmark} /> : undefined}
                                color={state.error && state.active === 2 ? 'red' : undefined}
                                loading={state.loading && state.active === 1 ? true : false}
                              />
                              <Stepper.Step label="Listo!" description="El archivo esta listo para ser descargado" />
                            </Stepper>

                            {/* ---- Status & Loader ---- */}
                            <Center mt="lg">
                              <p>Status: {state.status}</p>
                            </Center>

                            {/* ---- View Results Button ---- */}
                            {state.status === 'Archivo Listo para descarga' && (
                              <Button fullWidth mt="md" color="green" onClick={() => DescargaFunction(item.id)}>
                                Descargar reporte
                              </Button>
                            )}
                          </Grid.Col>
                        </Grid>
                      </Stack>
                    </Box>
                  </Accordion.Panel>
                </Accordion.Item>
              );
            })}
          </Accordion>
        </Paper>
      </div>

      {/* Pagination control */}
      {!loading && totalPages > 1 && (
        <div style={{ gridColumn: '1 / -1' }}>
          <Stack spacing="md" align="flex-end">
            <Paper height={2} shadow="lg" radius="lg" withBorder p="sm">
              <Pagination
                color="rgba(2, 12, 65, 1)"
                total={totalPages}
                value={page}
                onChange={setPage}
              />
            </Paper>
          </Stack>
        </div>
      )}
    </>
  );
}

export default AccordionWithFilter;